<template lang='pug'>
  BlockedEmailList(:title='title' v-if="$store.state.dataUsers.role=='super_user'")
</template>

<script>
import BlockedEmailList from "../components/BlockedEmailList.vue";
export default {
  name: "BlockedEmail",
  components: {
    BlockedEmailList
  },
  data: () => ({
    title: "Email Domain Block"
  }),
};
</script>

<style>
.v-main__wrap{
  background: #F3F3F4;
}

.v-application .blue {
  background-color: #01C8F1!important;
  border-color: #01C8F1!important;
}
</style>
